/** @format */
import axios from "axios";
import { getEnv } from "../../../../../lib/env";
import React, { useEffect, useState } from "react";
import {
  SettingOutlined,
  CloseOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import Fixer from "./fixer";
import { header } from "../../../../../components/api/Header";
import LoadingCard from "../../../../../components/loading/loadingCard";

const hcols = [
  0, //Hudud nomi 0
  2, //04.01-2025 1
  2, //kunlik Suv sarfi 2
  2, //jami sug'orish 3
  3, //G'alla ekishdan oldingi sho'r yuvish va nam suvi berish 4
  3, //Galla ekilgan maydon, ming ga 5
  1, //Reja 6
  1, //1 kunda 7
  1, //Jami (01.10.2025 dan) 8
  1, //Jami ekilgandan boshlab 9
  3, //Ochiq maydon 10
  3, //G'oza qator orasi 11
  2, //1-suv 12
  2, //2-suv 13
  2, //3-suv 14
  2, //4-suv 15
  2, //5-suv 16
  3, //Sho'r yuvishga yer tayyorlash, ming ga 17
  1, //Reja 18
  1, //1 kunda 19
  1, //Jami 20
  2, //1 - sho'r yuvish 21
  2, //2 - sho'r yuvish 22
  3, //Baxorgi Pushta va nam suv berish ishlari 23
  2, //Tomorqa va boshqa sug'orish ishlari 24
  1, //Sug’orish ishlarida qatnashgan suvchilar soni 25
];

const bcols = Array(58).fill(1);

const Table15 = ({ date }) => {
  const [c, setC] = useState(hcols);
  const [bc, setBc] = useState(bcols);
  const [data, setData] = useState([]);
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [year, month, day] = date.split("-");

  const regions = [
    "Qoraqalpog‘iston Respublikasi",
    "Andijon",
    "Buxoro",
    "Jizzax",
    "Qashqadaryo",
    "Navoiy",
    "Namangan",
    "Samarqand",
    "Surxondaryo",
    "Sirdaryo",
    "Toshkent",
    "Farg‘ona",
    "Xorazm",
    "Jami",
    `${Number(year) - 1} - yil`,
  ];

  const saveHandler = async () => {
    try {
      const data = { c, bolim: "vegetatsiya", bc };

      localStorage.setItem("vegetatsiya_data", JSON.stringify(data));

      alert("Ma'lumot saqlandi!");
    } catch (e) {
      console.log("Xato", e);
      alert("Saqlash jarayonida xato!");
    }
  };

  useEffect(() => {
    if (!date) return;

    const fetchAllData = async () => {
      setLoading(true);

      try {
        const vegCrudPromise = axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/sugorish/vegcrud?sana=${date}`,
          header()
        );

        const vegetatsiyaPromise = new Promise((resolve) => {
          const saved = localStorage.getItem("vegetatsiya_data");
          const parsed = saved ? JSON.parse(saved) : null;
          resolve(parsed);
        });

        const [vegCrudRes, vegetatsiyaData] = await Promise.all([
          vegCrudPromise,
          vegetatsiyaPromise,
        ]);

        setData(vegCrudRes?.data?.data || []);
        if (vegetatsiyaPromise?.c?.length > 1) setC(vegetatsiyaPromise.c);
        if (vegetatsiyaPromise?.bc?.length > 1) setBc(vegetatsiyaPromise.bc);

        console.log("LocalStorage Vegetatsiya:", vegetatsiyaData);
      } catch (error) {
        console.error("❌ Xatolik yuz berdi:", error);
        alert("Server bilan bog‘lanishda xatolik");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [date]);

  const fixValue = (value) => {
    const fixedValue = value === "" ? "" : Number(value).toFixed(1);

    return fixedValue;
  };

  return (
    <div className="table-responsive tableFixHead controllable-table-block">
      {menu ? (
        <div className="table-controls-close active d-flex justify-content-between">
          <button
            className="btn btn-sm btn-outline-primary d-flex align-items-center"
            onClick={() => saveHandler()}
          >
            Saqlash &nbsp;&nbsp;
            <SaveOutlined />
          </button>

          <CloseOutlined
            className="btn btn-secondary btn-sm"
            onClick={() => setMenu(false)}
          />
        </div>
      ) : (
        <div className="table-controls-open active">
          <SettingOutlined
            className="btn btn-secondary"
            onClick={() => setMenu(true)}
          />
        </div>
      )}

      <div
        className={menu ? "table-controls-menu active" : "table-controls-menu"}
      >
        <Fixer c={c} setC={setC} bc={bc} setBc={setBc} />
      </div>

      {loading ? (
        <LoadingCard heightSize="80vh" loading={loading} />
      ) : (
        <div id="vengetatsiya_table">
          <div style={{ width: "100%" }}>
            <table className="table table-bordered table-style" id="tblData">
              <thead>
                <tr>
                  <th className="st1 sticky" rowSpan={5}>
                    №
                  </th>

                  <th className="st1 sticky" rowSpan={5}>
                    Hududlar nomi
                  </th>

                  <th
                    colSpan={c[1] + c[2]}
                    style={{
                      display: c[1] + c[2] === 0 && "none",
                    }}
                  >
                    Sug’orish ishlariga olingan suv miqdori
                  </th>

                  <th
                    colSpan={sum(
                      c,
                      [
                        3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                        19, 20, 21, 22, 23, 24,
                      ]
                    )}
                    style={{
                      display:
                        sum(
                          c,
                          [
                            3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                            18, 19, 20, 21, 22, 23, 24,
                          ]
                        ) === 0 && "none",
                    }}
                  >
                    Sug’orilgan maydon, ming GA
                  </th>

                  <th
                    rowSpan={5}
                    scope="col"
                    colSpan={c[25]}
                    style={{
                      display: c[25] === 0 && "none",
                    }}
                  >
                    Sug’orish ishlarida qatnashgan suvchilar soni
                  </th>
                </tr>

                <tr>
                  <th
                    colSpan={c[1]}
                    scope="col"
                    style={{
                      display: c[1] === 0 && "none",
                    }}
                  >
                    01.10-01.04 {Number(year) + 1} y. mln.m3
                  </th>

                  <th
                    colSpan={2}
                    scope="col"
                    style={{
                      display: c[2] === 0 && "none",
                    }}
                  >
                    Kunlik suv sarfi m3/s.
                  </th>

                  <th
                    colSpan={c[3]}
                    scope="col"
                    style={{
                      display: c[3] === 0 && "none",
                    }}
                  >
                    Jami sug’orish ishlari
                  </th>

                  <th
                    colSpan={c[4]}
                    scope="col"
                    style={{
                      display: c[4] === 0 && "none",
                    }}
                  >
                    G'alla ekishdan oldingi sho'r yuvish va nam suvi berish
                  </th>

                  <th
                    colSpan={c[5]}
                    scope="col"
                    style={{
                      display: c[5] === 0 && "none",
                    }}
                  >
                    Galla ekilgan maydon, ming ga
                  </th>

                  <th
                    colSpan={sum(c, [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16])}
                    scope="col"
                    style={{
                      display:
                        sum(c, [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]) ===
                          0 && "none",
                    }}
                  >
                    G'alla sug'orish
                  </th>

                  <th
                    colSpan={c[17]}
                    scope="col"
                    style={{
                      display: c[17] === 0 && "none",
                    }}
                  >
                    Sho'r yuvishga yer tayyorlash, ming ga
                  </th>

                  <th
                    colSpan={sum(c, [18, 19, 20, 21, 22])}
                    scope="col"
                    style={{
                      display: sum(c, [18, 19, 20, 21, 22]) === 0 && "none",
                    }}
                  >
                    Sho'r yuvish, ming ga
                  </th>

                  <th
                    colSpan={c[23]}
                    style={{
                      display: c[23] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Baxorgi Pushta va nam suv berish ishlari
                  </th>

                  <th
                    colSpan={c[24]}
                    style={{
                      display: c[24] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Tomorqa va boshqa sug'orish ishlari
                  </th>
                </tr>

                <tr>
                  <th
                    rowSpan={3}
                    style={{
                      display: c[1] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Limit
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[1] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Amalda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[2] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Limit
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[1] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Amalda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[3] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[3] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[4] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[4] === 0 && "none",
                    }}
                    scope="col"
                  >
                    (01.10.{Number(year) - 1} y. dan)
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[4] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[5] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[5] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[5] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[6] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[7] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[8] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami (01.10.{year} dan)
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[9] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami ekilgandan boshlab
                  </th>

                  <th
                    colSpan={c[10] + c[11]}
                    style={{
                      display: c[10] + c[11] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Shu jumladan
                  </th>

                  <th
                    colSpan={sum(c, [12, 13, 14, 15, 16])}
                    style={{
                      display: sum(c, [12, 13, 14, 15, 16]) === 0 && "none",
                    }}
                    scope="col"
                  >
                    Shundan
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[17] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[17] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[17] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[18] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[19] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[20] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[21] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Amalda
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[22] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Amalda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[23] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[23] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[23] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[24] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda
                  </th>

                  <th
                    rowSpan={3}
                    style={{
                      display: c[24] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>
                </tr>

                <tr>
                  <th
                    colSpan={3}
                    style={{
                      display: c[10] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Ochiq maydon
                  </th>

                  <th
                    colSpan={3}
                    style={{
                      display: c[11] === 0 && "none",
                    }}
                    scope="col"
                  >
                    G'oza qator orasi
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[12] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 - suv
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[13] === 0 && "none",
                    }}
                    scope="col"
                  >
                    2 - suv
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[14] === 0 && "none",
                    }}
                    scope="col"
                  >
                    3 - suv
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[15] === 0 && "none",
                    }}
                    scope="col"
                  >
                    4 - suv
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[16] === 0 && "none",
                    }}
                    scope="col"
                  >
                    5 - suv
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[21] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 - sho'r yuvish
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      display: c[22] === 0 && "none",
                    }}
                    scope="col"
                  >
                    2 - sho'r yuvish
                  </th>
                </tr>

                <tr>
                  <th
                    style={{
                      display: c[10] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>
                  <th
                    style={{
                      display: c[10] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[10] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[11] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Reja
                  </th>
                  <th
                    style={{
                      display: c[11] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[11] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[12] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[12] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[13] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[13] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[14] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[14] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[15] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[15] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[16] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[16] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[21] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[21] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>

                  <th
                    style={{
                      display: c[22] === 0 && "none",
                    }}
                    scope="col"
                  >
                    1 kunda{" "}
                  </th>
                  <th
                    style={{
                      display: c[22] === 0 && "none",
                    }}
                    scope="col"
                  >
                    Jami
                  </th>
                </tr>
              </thead>

              {data.length > 0 ? (
                <tbody>
                  {regions.map((region, index) => (
                    <tr key={index}>
                      {index === 13 || index === 14 ? (
                        <td className="sticky st1 fix-with">{""}</td>
                      ) : (
                        <td className="sticky st1 fix-with">{index + 1}</td>
                      )}

                      <td className="sticky st1 fix-with">{region}</td>

                      {data[index]?.map((item, idx) => {
                        return (
                          <td
                            style={{ display: bc[idx] === 0 && "none" }}
                            key={idx}
                          >
                            {fixValue(item)}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  {regions.map((region, index) => (
                    <tr key={index}>
                      {index === 13 || index === 14 ? (
                        <td className="sticky st1 fix-with">{""}</td>
                      ) : (
                        <td className="sticky st1 fix-with">{index + 1}</td>
                      )}

                      <td className="sticky st1 fix-with">{region}</td>

                      {Array.from({ length: 48 }).map((_, ind) => {
                        return (
                          <td
                            style={{ display: bc[ind] === 0 && "none" }}
                            key={ind}
                          >
                            {""}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Table15;

const sum = (d, a) => {
  let s = 0;
  a.map((i) => (s += d[i]));
  return s;
};
